export default {
  processVConsole(url) {
    if (!url) {
      return '';
    }

    const newUrl = url.split('?')[0];

    if (!newUrl) {
      return '';
    }

    const urlParams = new URLSearchParams(window.location.search);
    const newUrlParams = new URLSearchParams(url.slice(url.indexOf('?')));

    // 網址參數有 "vconsole" 時啟用跳轉的目標頁的VConsole協助Debug
    if (urlParams.get('vconsole')) {
      newUrlParams.append('vconsole', '1');
    }

    return `${newUrl}?${newUrlParams.toString()}`;
  },
  checkedMobile() {
    return /ipad|iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase());
  },
};
